// Breadcrumb Component
// ====================

import React from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string; // Optional - if not provided, item is not clickable (current page)
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav aria-label="Brødkrumme" className="mb-4">
      {/* Feature #281: Explicitly set font-sans for consistent Inter typography */}
      <ol className="flex flex-wrap items-center gap-1 text-sm font-sans">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-4 h-4 mx-1 text-neutral-medium"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              )}

              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 hover:underline transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={isLast
                    ? 'font-medium text-neutral-dark dark:text-white'
                    : 'text-neutral-medium dark:text-gray-400'
                  }
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
